import React from "react";

export default function StatusBadge({ status }) {
  const active = (status || "Active") === "Active";
  return (
    <span
      data-testid={`status-${active ? "active" : "inactive"}`}
      className={`inline-flex items-center gap-1 text-xs font-semibold tracking-wide uppercase px-2 py-0.5 border ${
        active
          ? "border-emerald-500 text-emerald-700 dark:text-emerald-300"
          : "border-zinc-400 text-zinc-500"
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${active ? "bg-emerald-500" : "bg-zinc-400"}`} />
      {active ? "Active" : "Inactive"}
    </span>
  );
}
